import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixRicosV1RicosEmbeddablesUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/ricos/v1/embeddable-items',
        destPath: '/v1/embeddable-items',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/ricos-embeddables',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/ricos-embeddables',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/ricos-embeddables',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/ricos-embeddables',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/ricos/v1/embeddable-items',
        destPath: '/v1/embeddable-items',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/ricos/v1/embeddable-items',
        destPath: '/v1/embeddable-items',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_rich-content_ricos-embeddables';

/** Retrieves a specific embeddable item by ID and type. */
export function getEmbeddableItem(payload: object): RequestOptionsFactory<any> {
  function __getEmbeddableItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ricos.v1.embeddable_item',
      method: 'GET' as any,
      methodFqn: 'wix.ricos.v1.RicosEmbeddables.GetEmbeddableItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixRicosV1RicosEmbeddablesUrl({
        protoPath: '/v1/embeddable-items/{embeddableItemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'embeddableItem.eventDetails.startDate' },
              { path: 'embeddableItem.eventDetails.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getEmbeddableItem;
}

/** Lists embeddable items by type with optional search and pagination. */
export function listEmbeddableItems(
  payload: object
): RequestOptionsFactory<any> {
  function __listEmbeddableItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ricos.v1.embeddable_item',
      method: 'POST' as any,
      methodFqn: 'wix.ricos.v1.RicosEmbeddables.ListEmbeddableItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixRicosV1RicosEmbeddablesUrl({
        protoPath: '/v1/embeddable-items/list',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'items.eventDetails.startDate' },
              { path: 'items.eventDetails.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listEmbeddableItems;
}
